<div style="overflow: auto; height: 500px">
  <div virtual-repeat.for="item of items" style="height: 50px">${item.name}</div>
</div>
